import CustomElementTypeTabsSelector from './CustomElementTypeTabsSelector';

export default CustomElementTypeTabsSelector;
